module.exports = __webpack_public_path__ + "static/media/yopenLogo.b73a52eb.svg";